export enum EmoteReaction {
    Like = 1,
    Love = 2,
    Laugh = 3,
    Shock = 4,
    Angry = 5
}